<template>
  <div class="tinymce-editor">
    <TinymceEditor
      v-model="myValue"
      :inline="inline"
      :init="init"
      :key="tinymceFlag">

    </TinymceEditor>
  </div>
</template>
<script>
  import tinymce from 'tinymce/tinymce'
  import TinymceEditor from '@tinymce/tinymce-vue'
  import 'tinymce/themes/silver'
  import * as UploadAPI from '../../api/UploadAPI'
  // 编辑器插件plugins
  // 更多插件参考：https://www.tiny.cloud/docs/plugins/
  import 'tinymce/plugins/link' // 链接
  import 'tinymce/plugins/code' // 代码
  import 'tinymce/plugins/table' // 表单
  import 'tinymce/plugins/lists'
  import 'tinymce/plugins/contextmenu'
  import 'tinymce/plugins/wordcount'
  import 'tinymce/plugins/paste' // 张贴
  import 'tinymce/plugins/autosave' // 自动保存
  import 'tinymce/plugins/imagetools' // 图片
  import 'tinymce/plugins/image' // 插入上传图片插件
  import 'tinymce/plugins/media'// 插入视频插件

  // 自定义插件
  import './plugin/letterspacing/plugin' // 字间距
  import './plugin/indent/plugin' // 字间距
  import './plugin/lineheight/plugin' // 行高
  export default {
    components: {
      TinymceEditor
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      inline: {
        type: Boolean,
      },
      // 基本路径，默认为空根目录，如果你的项目发布后的地址为目录形式，
      // 即abc.com/tinymce，baseUrl需要配置成tinymce，不然发布后资源会找不到
      baseUrl: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      plugins: {
        type: [String, Array],
        default: 'link  table image  wordcount  autosave imagetools paste letterspacing indent lineheight'
      },
      toolbar: {
        type: String,
        default: `undo redo | fontsizeselect bold italic underline strikethrough  | forecolor backcolor | alignleft aligncenter alignright alignjustify |
              | link image media  table  pastetext removeformat | letterspacing indent lineheight`
      },
    },
    data() {
      return {
        tinymceFlag: 1,
        init: {
          forced_root_block: "",
          language_url: `./static/tinymce/zh_CN.js`,
          language: 'zh_CN',
          skin_url: `./static/tinymce/skins/ui/oxide`,
          content_css: `./static/tinymce/skins/content/default/content.css`,
          height: 300,
          plugins: this.plugins,
          toolbar: this.toolbar,
          branding: false,
          menubar: false,
          fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px 50px 56px 60px 64px',
          // 自定义字间距
          letterspacing_val: '1px 2px 3px 4px 5px',
          paste_data_images: true,
          setup: (editor) => {
            // 自定义新的工具栏按钮
            editor.ui.registry.addButton('customBtn', {
              tooltip: '新的工具栏按钮',
              text: '新的工具栏按钮',
              onAction: () => {
                window.alert('新的工具栏按钮')
              }
            })
          },
          images_upload_handler: function (blobInfo, success, failure) {
            let formData = new FormData()
            formData.append('img', blobInfo.blob())
            UploadAPI.uploadImage(blobInfo.blob(), (res) => {
              if (res.code == 200) {
                success(res.result.imgPath)
              } else {
                failure('上传失败！')
              }
            })
          },
        },
        myValue: this.value,
        isShowFileDlg: false
      }
    },
    mounted() {
    },
    activated() {
      this.tinymceFlag++;
    },
    methods: {
      escape2Html(str) {
        const arrEntities = {'lt': '<', 'gt': '>', 'nbsp': " ", 'ensp': '', 'emsp': '', 'amp': '&', 'quot': '"'};
        if (str) {
          return str.replace(/&(lt|gt|nbsp|emsp|ensp|amp|quot);/ig, function (all, t) {
            return arrEntities[t];
          });
        }
      },
      htmlEscape(text){
        return text.replace(/[<>"& ]/g, function (match, pos, originalText) {
          switch (match) {
            case "<":
              return "&lt;";
            case ">":
              return "&gt;";
            case ' ':
              return "&nbsp;";
            case "  ":
              return "&ensp;";
            case " ":
              return "&emsp;";
            case "&":
              return "&amp;";
            case "\"":
              return "&quot;";
          }
        });
      }
    },
    watch: {
      value(newValue) {
        newValue = this.escape2Html(newValue)
        this.myValue = newValue;
      },
      myValue(newValue) {
        newValue = this.htmlEscape(newValue);
        this.$emit('input', newValue)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tinymce/Tinymce.vue